<footer [style.background-color]="site['theme']['footerBackgroundColor']">
  <div class="container-fluid">
    <div *ngIf="footerLinks.length > 0"  class="row footer-links">
        <div class="col-xs-12">
            <customer-links-menu [links]="footerLinks" (returnToHome)="clickEvent.emit('cp_home_button')" ></customer-links-menu>
        </div>
    </div>
    <div class="row" 
      *ngIf="!isReadOnly || site['socialMedia']['facebook']['link'] || site['socialMedia']['youtube']['link'] || site['socialMedia']['twitter']['link']  || site['socialMedia']['twitter']['link']  || site['socialMedia']['instagram']['link']  || site['socialMedia']['linkedin']['link']">
        <div class="col-xs-12">
            <div id="social-media-container">
                
              <ng-content select=".social-media-editor"></ng-content>

                <ul id="social-media-icons">
                    <li *ngIf="site['socialMedia']['facebook']['link']">
                        <a
                          [href]="site['socialMedia']['facebook']['link']"
                          (click)="clickEvent.emit('cp_social_fb')"
                          target="_blank"
                        >
                            <i class="icon-facebook" aria-label="Facebook"></i>
                        </a>
                    </li>
                    <li *ngIf="site['socialMedia']['youtube']['link']">
                        <a
                          [href]="site['socialMedia']['youtube']['link']"
                          (click)="clickEvent.emit('cp_social_yt')"
                          target="_blank"
                        >
                          <i class="icon-youtube" aria-label="YouTube"></i>
                        </a>
                    </li>
                    <li *ngIf="site['socialMedia']['twitter']['link']">
                        <a
                          [href]="site['socialMedia']['twitter']['link']"
                          (click)="clickEvent.emit('cp_social_twt')"
                          target="_blank"
                        >
                          <i class="icon-twitter" aria-label="Twitter"></i>
                        </a>
                    </li>
                    <li *ngIf="site['socialMedia']['instagram']['link']">
                        <a
                          [href]="site['socialMedia']['instagram']['link']"
                          (click)="clickEvent.emit('cp_social_inst')"
                          target="_blank"
                        >
                          <i class="icon-instagram" aria-label="Instagram" ></i>
                        </a>
                    </li>
                    <li *ngIf="site['socialMedia']['linkedin']['link']">
                        <a
                          [href]="site['socialMedia']['linkedin']['link']"
                          (click)="clickEvent.emit('cp_social_li')"
                          target="_blank"
                        >
                          <i class="icon-linkedin" aria-label="LinkedIn" ></i>
                        </a>
                    </li>
                </ul>

                <ng-content select=".btn-editor"></ng-content>

            </div>
        </div>
    </div>
    <ng-content select=".customer-site-footer-copy"></ng-content>
  </div>
</footer>